import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState, useRef, useEffect } from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { modalClasses } from '../modal.classes';
import { useModalBodySectionedScrollStyles } from './modalBody.styles';
/**
 * The scrollable content area of the Modal.
 * The modal body contains a fixed section and a scrollable section.
 * If there is enough space, only the scrollable section can be scrolled.
 * If the modal body height is too small, the scrollable section becomes fixed, and the entire modal body scrolls instead.
 */ export const ModalBodySectionedScroll = ({ fixedSection, scrollableSection, styles })=>{
    const modalBodyRef = useRef(null);
    const fixedSectionRef = useRef(null);
    const [scrollBehavior, setScrollBehavior] = useState('inner');
    const css = useModalBodySectionedScrollStyles(scrollBehavior);
    useEffect(()=>{
        const updateScrollBehavior = ()=>{
            if (!modalBodyRef.current || !fixedSectionRef.current) return;
            const offset = 100;
            const modalBodyHeight = modalBodyRef.current.clientHeight;
            const fixedSectionHeight = fixedSectionRef.current.clientHeight;
            const remainingHeight = modalBodyHeight - (fixedSectionHeight + offset);
            setScrollBehavior(remainingHeight <= 0 ? 'outer' : 'inner');
        };
        updateScrollBehavior();
        window.addEventListener('resize', updateScrollBehavior);
        return ()=>window.removeEventListener('resize', updateScrollBehavior);
    }, []);
    return /*#__PURE__*/ _jsxs(Stack, {
        ref: modalBodyRef,
        className: modalClasses.body,
        style: styles,
        css: css.body,
        children: [
            /*#__PURE__*/ _jsx(Box, {
                ref: fixedSectionRef,
                css: css.fixedSection,
                children: fixedSection
            }),
            /*#__PURE__*/ _jsx(Box, {
                css: css.scrollableSection,
                children: scrollableSection
            })
        ]
    });
};

//# sourceMappingURL=modalBodySectionedScroll.js.map